import { api } from '../api'
import type { MetaResponse, Company } from '@homeviews/models'

interface ICompaniesResponse {
  data: Company[]
  meta: MetaResponse
}

export const companiesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getCompanies: builder.query<ICompaniesResponse, void>({
      query: () => {
        return {
          url: '/companies',
        }
      },
    }),
    getCompanyStatus: builder.query({
      query: (id) => {
        return {
          url: `/onboarding/${id}`,
        }
      },
    }),
    upgradeCompany: builder.mutation({
      query: ({ developerId, data }) => {
        return {
          url: `/companies/${developerId}/requests/premium`,
          method: 'POST',
          body: data,
        }
      },
    }),
  }),
})

export const {
  useGetCompaniesQuery,
  useGetCompanyStatusQuery,
  useUpgradeCompanyMutation,
} = companiesApi
